// Function to check if both sizes are hidden for a given color
function areAllSizesHidden(color) {
  if (!hiddenStatus[color]) {
    return false
  }

  const sizes = Object.keys(hiddenStatus[color])

  return sizes.every(function (size) {
    return hiddenStatus[color][size]
  })
}

async function setCartAttributes(attributes = {}) {
  const result = await fetch("/cart/update.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      attributes: attributes
    })
  });

  return result.json();
}

async function updateItem(data) {
  const result = await fetch("/cart/change.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(data)
  });

  return result.json();
}

function updateItemById(lineItemId, newQuantity, newProperties = {}) {
  return updateItem({
    id: lineItemId,
    quantity: newQuantity,
    properties: newProperties
  });
}

/**
* @desc    Generate selected swatch selector
* @param   {String} selector    Swatch selector
* @param   {String} size        If size swatch is selected
* @param   {String} color       If color swatch is selected
* @param   {String} material    If material swatch is selected
* @return  Return selected swatch selector
*/
function generateSwatchSelector(selector, color, size, material) {
  if (color) {
    selector = `${selector}[data-color-option="${escapeSelector(color)}"]`
  }

  if (size) {
    selector = `${selector}[data-size-option="${size}"]`
  }

  if (material) {
    selector = `${selector}[data-material-option="${material}"]`
  }

  return selector
}

/**
* @desc    Replace special charater from string
* @param   {String} str        String
* @return  {String}
*/
function escapeSelector(str) {
  //check if str is number
  if (!isNaN(str)) {
    return str
  }

  return str ? str.replace(/(:|\.|\[|\])/g, '\-') : '';
}

/*
* Convert swatch value to lowercase
* and replace space with -
*/
function swatchToLowerCase(input) {
  if (!input) { return }
  if (!isNaN(input)) { return input }

  return input
    .toLowerCase()
    .replace(/\s+/g, '-');
}

function toLowerCase(input) {
  if (!input) { return }

  return input
    .toLowerCase();
}

function displayQtyCount(qty, label) {
  if (parseInt(qty, 10) > 0 && parseInt(qty, 10) < 2) {
    return `${label} 残り${qty}点`
  }

  return label
}

/*
* Show/Hide availability labels for quantity
*/
function showHideQantityLabel(available) {
  if (JSON.parse(available)) {
    $('button > span#js-variant-pre-order-button').text('予約する');
  } else {
    $('button > span#js-variant-pre-order-button').text('売り切れ');
  }
}

/*
* Calculate delivery date for each variant
*/
function calculateVariantDeliveryDate(
  dataQty,
  selectedOption,
  dataDeliveryDay,
  preOrderDeliveryDay,
  dataRent,
  isAvailable) {
  const weekDaySpanSelector = '.js-variant-available-message > .js-stock-label'
  const isFixedDeliverySchedule = selectedOption.attr('data-is-fixed-delivery-applicable')
  const qty = parseInt(selectedOption.attr(dataQty), 10)
  const isRent = selectedOption.attr(dataRent)

  const deliveryLabel = window.getDeliveryLabel({
    isFixedDelivery: isFixedDeliverySchedule ? JSON.parse(isFixedDeliverySchedule) : false,
    fixedDate: selectedOption.attr('data-fixed-delivery-date') ? selectedOption.attr('data-fixed-delivery-date').replaceAll('-', '/') : '',
    isAvailable: JSON.parse(isAvailable),
  }, qty)

  if (deliveryLabel.date === 'FIXED') {
    $('#js-cart-item-property').val('予約商品')
    $(weekDaySpanSelector).html(deliveryLabel.label)
  } else {
    let deliveryLabelText = ''

    if (deliveryLabel.date === 'PRE_ORDER') {
      $('#js-cart-item-property').val('受注生産商品')
    }

    if (isRent && isRent === 'true' && qty > 0) {
      deliveryLabelText = displayQtyCount(qty, '貸し出し')
      $('#js-cart-item-property').val('受注生産商品')
    } else if (qty > 0) {
      deliveryLabelText = displayQtyCount(qty, '')
      $('#js-cart-item-property').val('在庫あり商品')
    }

    if (deliveryLabelText) {
      $(weekDaySpanSelector).html(deliveryLabelText)
    } else {
      $(weekDaySpanSelector).html('')
    }
  }
}

/*
* Find value from query string
*/
function findQueryString(key) {
  key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&")

  const match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"))

  return match && decodeURIComponent(match[1].replace(/\+/g, " "))
}

/*
* Select swatch on page reload
*/
function selectSwatchRadio(optionValue) {
  $(`.js-swatch-option-radio[value="${optionValue}"]`).attr('checked', true)
}

function showHideBISLabel(available) {
  $('.js-product-detail-content__info .shopify-bis-trigger').removeAttr('style')

  if (available) {
    $('.js-product-detail-content__info .js-variant-sold-out-label').css('visibility', 'hidden')
    $('.js-product-detail-content__info .shopify-bis-trigger').addClass('display-none');
    $('.js-product-detail-content__info .js-info-cta').css('display', 'block')
  } else {
    $('.js-product-detail-content__info .js-variant-sold-out-label').css('visibility', 'visible')
    $('.js-product-detail-content__info .shopify-bis-trigger').removeClass('display-none');
    $('.js-product-detail-content__info .js-info-cta').css('display', 'none')
  }
}

/*
* Filter swatch on selection on parent swatch
*/
function filterSwatch(swatchName, swatchType) {
  if (swatchType == 'material') {
    $('fieldset.js-fieldset-color').show()
    $('.js-swatch-option-li.js-swatch-color').hide()

    const selector = $(`input.sizeColorOption[data-material-option="${swatchName}"]`)
    const options = $(selector)

    $.each(options, (i, option) => {
      $(`.js-swatch-option-li.js-swatch-color.color-${escapeSelector($(option).attr('data-color-option'))}`).show()
    })

    selectSwatchRadio(swatchName)

    const defaultColour = $(`input.js-swatch-option-radio.js-swatch-color:checked`)
    const defaultColourLabel = $(`.js-swatch-option-li.js-swatch-color.color-${escapeSelector(defaultColour.val())}`)

    if (!defaultColourLabel.is(':visible')) {
      $('.js-swatch-option-li.js-swatch-color:visible:first').trigger('click')
      $('.js-swatch-option-li.js-swatch-color:visible:first').trigger('mouseenter')
    }
  }

  if (swatchType == 'color') {
    $('fieldset.js-fieldset-size').show()

    const materialSelector = 'input.js-swatch-option-radio.js-swatch-material:checked'
    const selectedMaterial = $(materialSelector)
    let sizeColor = `input.sizeColorOption[data-color-option="${swatchName}"]`

    if (selectedMaterial.length) {
      sizeColor = `${sizeColor}[data-material-option="${selectedMaterial.val()}"]`
    }

    $('.js-swatch-option-li.js-swatch-size').hide()

    const options = $(sizeColor)

    $.each(options, (i, option) => {
      $(`.js-swatch-option-li.js-swatch-size.size-${escapeSelector($(option).attr('data-size-option'))}`).show()
    })

    const defaultSize = $(`input.js-swatch-option-radio.js-swatch-size:checked`)
    const defaultSizeLabel = $(`.js-swatch-option-li.js-swatch-size.size-${escapeSelector(defaultSize.val())}`)

    if (!defaultSizeLabel.is(':visible')) {
      $('.js-swatch-option-li.js-swatch-size:visible:first').trigger('click')
    }
  }

  hideVariant()
}

/**
* @desc    Common function to hide unavailable variant
* @param   {String} selector     Selector to find variant to hide
* @param   {String} swatchType   Type of swatch to hide
* @param   {String} optionIndex  Swatch index value
* @return  {N/A}
*/
function singletonSwatchShowHide(selector, swatchType, optionIndex) {
  const variantToHide = $(selector)

  if (variantToHide.length) {
    $.each(variantToHide, (i, variant) => {
      const variantToHideOption = $(variant).data(optionIndex)

      $(`.js-swatch-option-li.js-swatch-${swatchType}.${swatchType}-${escapeSelector(variantToHideOption)}`).hide()
    })
  }

  $.each($(`.js-swatch-option-li.js-swatch-color`), (i, variant) => {
    const color = $(variant).data('value')

    if (areAllSizesHidden(color)) {
      $(`.js-swatch-option-li.js-swatch-color.${color}`).hide()
    }
  })
}

/**
* @desc    Hide variant which are set to hidden
* @return  {N/A}
*/
function hideVariant() {
  let materialElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-material:checked').data('unescaped-value'))
  let colorElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-color:checked').data('unescaped-value'))
  let sizeElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-size:checked').data('unescaped-value'))

  let finalSelector = 'input.js-hidden-variant-options'
  let swatchType = 'size'
  let optionIndex = 'size-index'

  if (sizeElement && colorElement && materialElement) {
    finalSelector = `${finalSelector}[data-material-index="${materialElement}"][data-color-index="${escapeSelector(colorElement)}"]`
  } else if (sizeElement && colorElement && !materialElement) {
    finalSelector = `${finalSelector}[data-color-index="${escapeSelector(colorElement)}"]`
  } else if (colorElement && materialElement && !sizeElement) {
    finalSelector = `${finalSelector}[data-material-index="${materialElement}"]`
    swatchType = 'color'
    optionIndex = 'color-index'
  } else if (colorElement && !materialElement && !sizeElement) {
    swatchType = 'color'
    optionIndex = 'color-index'
  } else if (!colorElement && materialElement && !sizeElement) {
    swatchType = 'material'
    optionIndex = 'material-index'
  }

  setTimeout(() => {
    if (!$(`.js-swatch-option-li.js-swatch-${swatchType}:visible`).length) {
      $(`fieldset.js-fieldset-${swatchType}`).hide()
    }
  }, 100)

  singletonSwatchShowHide(
    finalSelector,
    swatchType,
    optionIndex,
  )
}

/**
* @desc    Update the query string parameters
* @param   {String} key     query parameter
* @param   {String} value   query parameter value
* @param   {String} url     default to current url else pass url string
* @return  {N/A}
*/
function updateQueryString(key, value, url) {
  if (!url) url = window.location.href;

  let updated = ''
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash;

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
    }
    else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      updated = url;
    }
  }
  else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      updated = url;
    }
    else {
      updated = url;
    }
  }

  window.history.replaceState({ path: updated }, '', updated);
}

hiddenStatus = {}
const hiddenInputs = document.querySelectorAll('.js-hidden-variant-options')

// Loop through all hidden inputs to initialize the hiddenStatus object
hiddenInputs.forEach(function (input) {
  const color = input.getAttribute('data-color-index')
  const size = input.getAttribute('data-size-index')

  // Initialize hiddenStatus for the color if not exists
  if (!hiddenStatus[color]) {
    hiddenStatus[color] = {}
  }

  // Set hidden status for the size
  hiddenStatus[color][size] = true
})

$(window).on('load', function () {
  const materialQS = findQueryString('variant-material')
  const colorQS = findQueryString('variant-color')
  const sizeQS = findQueryString('variant-size')

  selectSwatchRadio(swatchToLowerCase(materialQS))
  selectSwatchRadio(swatchToLowerCase(colorQS))
  selectSwatchRadio(swatchToLowerCase(sizeQS))

  /**
   * Swatch click handler
   */
  $('.js-swatch-option-li').on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $this = $(this)
    const optionValue = $this.data('value')
    const isMaterial = $this.hasClass('js-swatch-material')
    const isColor = $this.hasClass('js-swatch-color')
    const isSize = $this.hasClass('js-swatch-size')
    const optionClass = isSize ? 'js-swatch-size' : (isMaterial ? 'js-swatch-material' : 'js-swatch-color')
    const swatchLowerCase = swatchToLowerCase(optionValue)

    $(`.js-swatch-option-radio.${optionClass}`).removeAttr('checked')

    selectSwatchRadio(optionValue)

    const swatchType = isColor ? 'color' : (isSize ? 'size' : 'material')

    filterSwatch(swatchLowerCase, swatchType)

    updateQueryString(
      'variant-color',
      swatchToLowerCase($('.js-swatch-option-radio.js-swatch-color:checked').val())
    )
    updateQueryString(
      'variant-size',
      swatchToLowerCase($('.js-swatch-option-radio.js-swatch-size:checked').val())
    )
    updateQueryString(
      'variant-material',
      swatchToLowerCase($('.js-swatch-option-radio.js-swatch-material:checked').val())
    )

    $('span.js-swatch-option-name.js-swatch-label-color').html($('.js-swatch-option-radio.js-swatch-color:checked').data('unescaped-value'))
    $('span.js-swatch-option-name.js-swatch-label-size').html($('.js-swatch-option-radio.js-swatch-size:checked').data('unescaped-value'))

    setTimeout(async function () {
      let materialElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-material:checked').data('unescaped-value'))
      let colorElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-color:checked').data('unescaped-value'))
      let sizeElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-size:checked').data('unescaped-value'))

      if (materialElement && materialElement.indexOf('.') == -1) {
        materialElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-material:checked').val())
      }

      if (colorElement && colorElement.indexOf('.') == -1) {
        colorElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-color:checked').val())
      }

      if (isNaN(sizeElement) && sizeElement && sizeElement.indexOf('.') == -1) {
        sizeElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-size:checked').val())
      }

      const sizeColorSelector = generateSwatchSelector(
        'input.sizeColorOption',
        colorElement,
        sizeElement,
        materialElement,
      )

      const selectedOption = $(sizeColorSelector)
      const variantId = selectedOption.data('available-id')

      $('#js-selected-variant-id').val(variantId)
      $('form#js-product_form_id input[name="id"]').val(variantId)

      updateQueryString('variant', variantId)
      showHideBISLabel(selectedOption.data('available'))
      showHideQantityLabel(
        selectedOption.attr('data-available')
      )

      if (selectedOption.data('available')) {
        $('button#js-product-add-to-cart').removeAttr('disabled')
        $('button#js-product-add-to-cart').removeClass('is-disabled')
      } else {
        $('button#js-product-add-to-cart').prop('disabled', true)
        $('button#js-product-add-to-cart').addClass('is-disabled')
      }

      $('.js-vaiant-price').html(selectedOption.data('price'))

      calculateVariantDeliveryDate(
        'data-available-qty',
        selectedOption,
        'data-delivery-days',
        'data-preorder-delivery-days',
        'data-rent',
        selectedOption.attr('data-available')
      )
    }, 100);
  })

  /**
   * If product have single variant
   */
  const isSingleVariant = $('input.sizeColorOption').length

  if (isSingleVariant === 1) {
    processDefaultVariant($('input.sizeColorOption'))
  }

  /**
   * If product have default variant
   */
  function processDefaultVariant(defaultSelector) {
    const hasOnlyDefaultVariant = defaultSelector
      ? defaultSelector
      : $('input.hasOnlyDefaultVariant')

    if (hasOnlyDefaultVariant.length) {
      showHideBISLabel(hasOnlyDefaultVariant.data('available'))

      showHideQantityLabel(
        hasOnlyDefaultVariant.attr('data-available')
      );

      calculateVariantDeliveryDate(
        'data-available-qty',
        hasOnlyDefaultVariant,
        'data-delivery-days',
        'data-preorder-delivery-days',
        'data-rent',
        hasOnlyDefaultVariant.attr('data-available')
      );
    }
  }

  processDefaultVariant()

  /**
   * Code which trigger click for last selected variant on page reload
   */
  const selectedColorOption = $('input.js-swatch-option-radio.js-swatch-color:checked')
  const materialSelector = 'input.js-swatch-option-radio.js-swatch-material'
  const isMaterial = $(materialSelector)

  if (isMaterial.length) {
    const materialElement = `${materialSelector}:checked`
    const material = $(materialElement).val()

    if (material) {
      $(`.js-swatch-option-li.js-swatch-material.${material}`).trigger('click')
    } else {
      $(`.js-swatch-option-li.js-swatch-material:visible:first`).trigger('click')
    }
  } else if (selectedColorOption.length) {
    $(`.js-swatch-option-li.js-swatch-color.${selectedColorOption.val()}`).trigger('click')
  } else {
    $('.js-swatch-option-li.js-swatch-color:visible:first').trigger('click')
  }
})